import { Application } from './Application'

export class AccountManager {
    constructor(private Application: Application) {
    }

    public Init() {
        const $headerContainer = $("div.header__main");

        $(".reset-password").on("click", this.SendPasswordResetEmail)

        if (window.location.pathname.toLocaleLowerCase() === "/account/login") {
            return;
        }

        $.ajax(
            {
                url: "/user",
                dataType: "html"
            }
        ).done((data: string) => {
            $headerContainer.append(data);

            if ($headerContainer.find("form").length === 0) {
                var $body = $("body");
                if ($body.hasClass("hwbt")) {
                    $("body").removeClass().addClass("authenticated").addClass("hwbt");
                } else {
                    $("body").removeClass().addClass("authenticated");
                }
            }

            let returnUrl = window.location.pathname + window.location.search;

            if (returnUrl === "/") {
                returnUrl = "";
            }

            $headerContainer.find("input[type=hidden]").val(returnUrl);

            this.Application.SetupValidation();
        });
    }

    private SendPasswordResetEmail() {
        var email = $("input#email").val();

        $.ajax(
            {
                url: "/account/passwordrecoveryrequest",
                type: "POST",
                dataType: 'json',
                data: {
                    email: email
                }
            }
        ).done((data) => {
            $("#login-notification-text").html(data.Message);

            if (data.Success) {
                $("#login-notification-text").switchClass("error-alert", "info-alert");
            }
            else {
                $("#login-notification-text").switchClass("info-alert", "error-alert");
            }
           
        }).fail(() => {
            $("#login-notification-text").html("An error occurred while trying to reset password");
        });
    }
}
